<template>
  <div class="ranking">
    <slot></slot>
    <div class="body">
      <div class="bar-container"  v-for="(item, index) in newData" :key="index"  :class="{'hover-item': !!item.message}" >
        <div class="bar-header">
          <span v-if="isShowIndex" class="index" :class="{ 'front-index': index === 0 || index === 1 || index === 2}">{{index+1}}</span>
          <span v-if="item.messageAlias" class="category" :class="{'click-message':selectedMessage === item.message&&defaultMessage  }"  @click="onMessage(item)">{{item.messageAlias}}</span>
          <span v-else class="category" :class="{'click-message':selectedMessage === item.message&&defaultMessage  }"  @click="onMessage(item)">{{item.message}}</span>
          <span class="word-count">
            <span v-if="item.count" class="count">{{item.count}}</span>
            <span v-else class="count">{{item.num}}</span>
            <span v-if="showUnit" class="word">条</span>
          </span>
        </div>
        <div :class="item.sentiment" :style="{width: `${item.width}%`, height: `${4}px`}"></div>
        <div :class="sentiment" :style="{width: `${item.width}%`, height: `${4}px`}"></div>
      </div>
    </div>
  </div>
</template> 

<script>
export default {
  data() {
    return {
      selectedMessage: this.defaultMessage
    };
  },
  props: {
    emitData: {
      type: Function
    }, 
    isShowIndex: {
      type: Boolean
    },
    data: {
      type: Array
    },
    rankingTitle: {
      type: String
    },
    sentiment: {
      type: String
    },
    defaultMessage: {
      type: String
    },
    showUnit: {
      type: Boolean
    }
  },
  methods: {
    onMessage(item) {
      this.emitData(item);
      this.selectedMessage = item.message;
    }
  },
  watch: {
    defaultMessage(newDefaultMessage) {
      this.selectedMessage = newDefaultMessage;
    }
  },
  computed: {
    newData() {
      if (this.data.length > 0) {
        let dataMap;
        if (this.data[0].num < 0) {
          dataMap = this.data.map((item) => {
            return {
              name: item.name,
              count: item.num,
              num: -item.num,
              messageAlias: item.messageAlias,
              message: item.message,
              sentiment: item.sentiment
            };
          });
        } else {
          dataMap = this.data.map((item) => {
            return {
              name: item.name,
              num: item.num,
              messageAlias: item.messageAlias,
              message: item.message,
              sentiment: item.sentiment
            };
          });
        }
        const dataSort = dataMap.sort((a, b) => {
          return b.num > a.num ? 1 : -1;
        });
        const ratio = dataSort[0].num;
        const data1 = dataSort.map(item => {
          return {
            name: item.name,
            messageAlias: item.messageAlias,
            message: item.message,
            num: item.num,
            count: item.count,
            sentiment: item.sentiment,
            width: item.num / ratio * 100
          };
        });
        return data1;
      }
      return [];
    }
  }
};
</script>

<style lang="scss" scoped>
.ranking {
  background-color: transparent;
  border-radius: 8px;
  .body {
    .hover-item:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
    .bar-container {
      height: 44px;
      padding: 10px 24px;
      .bar-header {
        overflow:hidden;
        .front-index {
          color: #ffffff !important;
          font-family: DIN-Bold;
        }
        .index {
          margin-right: 16px;
          color: rgba(255, 255, 255, 0.9);
          font-size: 16px; 
        }
        .word-count {
          float: right;
          .count {
            font-size: 16px;
            font-family: DIN-Bold;
            color: rgba(255, 255, 255, 0.9);
          }
          .word {
            display: inline-block;
            margin-top: 2px;
            margin-left:2px;
            color: #ffffff;
            font-family: DIN-Regular;
            font-size: 12px;
          }
        }
        .category {
          color: rgba(255, 255, 255, 0.6);
          font-size: 14px;
          cursor: pointer;
        }
        .click-message {
          color:#ffffff;
        }
      }
      .bar {
        margin-top: 4px;
      }
    }
  }
}
.sentiment {
  margin-top:4px;
  background-image: linear-gradient(
    90deg,
    rgba(178, 69, 99, 0.3) 0%,
    #b2454c 100%
  );
}
.positive {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-image: linear-gradient(90deg, rgba(178, 69, 99, 0.3) 0%, #b2454c 100%);
}
.negative {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-image: linear-gradient(90deg, rgba(37, 142, 124, 0.3) 0%, #468b6b 100%);
}
.neutral, .all {
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  background-image: linear-gradient(90deg, rgba(238, 238, 248, 0.1) 0%, rgba(255, 255, 255, 0.5) 100%);
}
</style>
